export default {
  FACEBOOK_CONNECTION: 'https://www.facebook.com/groups/Tripsha',
  INSTAGRAM_CONNECTION: 'https://www.instagram.com/tripshatravel/?hl=en',
  TWITTER_CONNETION: 'https://twitter.com/tripshatravel',
  PINTEREST_CONNETION: 'https://www.pinterest.com/tripshatraveler/',
  MAIL_ADDRESS: 'mailto:Hello@tripsha.com',
  OUR_STORY: 'https://www.tripsha.com/our-story',
  EVENTS:
    'https://www.notion.so/tripsha/Events-ee748d8dbe314e7a8ac8e0104d9ebc40',
  CAREERS:
    'https://www.notion.so/tripsha/Careers-05056d599266417eb440d879d0e70fd5',
  POLICIES: 'https://www.tripsha.com/policies',
  POLICIES_CANCELLATION:
    'https://www.tripsha.com/policy/refunds-cancellations-policy',
  FAQS: 'https://www.tripsha.com/faqs',
  MILLISECONDS: 1000,
  CURRENT_USER_STORAGE: 'CURRENT_USER_STORAGE',
  CURRENT_ONBOARDING_STEP: 'CURRENT_ONBOARDING_STEP',
  FIELD_TYPES: {
    ONE_LINE: 'OneLine',
    MULTI_LINE: 'MultiLine',
    ONE_CHOICE: 'OneChoice',
    MULTI_CHOICE: 'MultiChoice',
    FILE_UPLOAD: 'UploadFile',
    URL: 'Url',
    DATE: 'Date',
    DATE_RANGE: 'DateRange',
    DATE_TIME: 'DateTime',
    TIME: 'Time',
    CONSENT: 'Consent',
    AUTO_COMPLETE: 'AutoComplete',
    YES_NO: 'YesNo',
    READ_ONLY: 'read_only',
    GEOGRAPHY_BASED_DISCOUNT: 'GeographyBasedDiscount',
    AGE_BASED_DISCOUNT: 'AgeBasedDiscount',
  },
  FIELD_CATEGORIES: {
    GENERAL: 'General',
    MEMBER_DIRECTORY: 'Member Directory',
    QUESTIONS: 'Questions',
    RESOURCES: 'Resources',
    PAYMENT: 'Payments',
    BOOKING: 'Booking',
  },
  RESOURCE_TYPES: {
    VENUE: 'Venue',
    VENUE_KEY: 'venue',
    GROUND_TRANSPORT_KEY: 'ground_transport',
    GROUND_TRANSPORT: 'Ground Transport',
    FLIGHT: 'Flight',
    FLIGHT_KEY: 'flight',
  },
  COMMON_ERROR_MESSAGE:
    "We’ve encountered an unexpected error. Please try again and contact us at hello@tripsha.com if the error persists.",
  CC_CHARGE_FEE: 2.9, // This is pecent value
  CC_CHARGE_FIXED_VALUE: 0.3,



  INVITE_SUBJECT_DEFAULT:
    "You have been invited to join the event!",
  INVITE_MAIL_DEFAULT:
    `Hi #FirstName,
     <br/>
     #HostOrg is inviting you to attend #EventName
     <br/>
     <br/>
     As always, please feel free to message us from your Tripsha inbox if you need any assistance.
     <p><em>Sent via Tripsha</em></p>
     <br/>`,
  INVITE_MAIL_PLACEHOLDER_DEFAULT:
    `Hi #FirstName,
    #HostOrg is inviting you to attend #EventName

    As always, please feel free to message us from your Tripsha inbox if you need any assistance.
    Sent via Tripsha`,



  BOOKING_REQUEST_SUBJECT_DEFAULT:
    `You submitted a Booking Request to join #EventName`,
  BOOKING_REQUEST_MAIL_DEFAULT:
    `Hi #FirstName,
    <br/>
    You submitted a Booking Request to join #EventName. Please allow time for the organizer to review your request. You can withdraw your request at any time from your Tripsha dashboard.
    <br/>
    <br/>
    <p><em>Sent via Tripsha</em></p>
    <br/>`,
  BOOKING_REQUEST_MAIL_PLACEHOLDER_DEFAULT:
    `Hi #FirstName,
    You submitted a Booking Request to join #EventName. 
    Please allow time for the organizer to review your request. 
    You can withdraw your request at any time from your Tripsha dashboard.

    Sent via Tripsha`,



  BOOKING_REQUEST_WITHDRAWN_SUBJECT_DEFAULT:
    `You withdrew your booking request for #EventName`,
  BOOKING_REQUEST_WITHDRAWN_MAIL_DEFAULT:
    `Hi #FirstName,
    <br/>
    You withdrew your booking request for #EventName. You may submit a new booking request if you choose.
    <br/>
    <br/>
    <p><em>Sent via Tripsha</em></p>`,
  BOOKING_REQUEST_WITHDRAWN_MAIL_PLACEHOLDER_DEFAULT:
    `Hi #FirstName,
     You withdrew your booking request for #EventName.
     You may submit a new booking request if you choose.

     Sent via Tripsha`,



  REGISTERED_SUBJECT_DEFAULT:
    `You are registered to attend #EventName`,
  REGISTERED_MAIL_DEFAULT:
    `Hi #FirstName, 
    <br/>
    You are registered to attend #EventName.
    <br/>
    <br/>
    <p><em>Sent via Tripsha</em></p>`,
  REGISTERED_MAIL_PLACEHOLDER_DEFAULT:
    `Hi #FirstName,
    You are registered to attend #EventName.
                                    
    Sent via Tripsha`,



  BOOKING_REQUEST_EXPIRED_SUBJECT_DEFAULT:
    `Your booking request on #EventName has expired`,
  BOOKING_REQUEST_EXPIRED_MAIL_DEFAULT:
    `Hi #FirstName,
    <br/>
    Your booking request on #EventName has expired. You may submit a new booking request if you choose.
    <br/>
    <p><em>Sent via Tripsha</em></p>
    `,
  BOOKING_REQUEST_EXPIRED_MAIL_PLACEHOLDER_DEFAULT:
    `Hi FirstName,
    Your booking request on #EventName has expired. 
    You may submit a new booking request if you choose.

    Sent via Tripsha`,
}

export const DEFAULT_SERVICE_FEE_PERCENT = 2
export const ETH_MAINNET_FEE_USD = 0
